<template>
    <div>
        <Row :gutter="20">
            <Col span="8">
                <table-tool-bar>
                    <template slot="left">
                        <span style="margin-left: 10px">授权模块</span>
                    </template>
                </table-tool-bar>
                <Table
                    ref="mt"
                    :columns="columns"
                    :data="moduleList"
                    highlight-row
                    :loading="loading"
                    :height="mtHeight"
                    @on-current-change="chooseModule"
                ></Table>
            </Col>
            <Col span="16">
                <table-tool-bar></table-tool-bar>
                <div class="topRail">被授权人</div>
                <div class="peopleBox">
                    <form-lookup
                        placeholder="请选择被授权员工"
                        :disabled="loading"
                        title="选择被授权员工"
                        :modalHeight="600"
                        :modalWidth="900"
                        textSymbol="nickname"
                        v-model="peopleIds"
                        :options.sync="empOptions"
                        @change="lookupChange"
                    >
                        <select-inside multiple></select-inside>
                    </form-lookup>
                </div>
            </Col>
        </Row>
    </div>
</template>
<style lang="less" scoped>
.topRail {
    height: 40px;
    line-height: 40px;
    border: 1px solid @border-color-base;
    border-bottom: 0;
    background-color: @table-thead-bg;
    text-align: center;
    font-weight: bold;
}
.peopleBox {
    height: 380px;
    border: 1px solid @border-color-base;
    box-sizing: border-box;
    padding: 20px;
}
</style>
<script>
import Dict from '_u/dict'
import { mapCell } from '@/components/grid/renderCell'
import dayjs from 'dayjs'
import { queryAuth, doAuth } from '@/api/sys-res'
const WINDOW_HEIGHT = document.body.clientHeight
const PAGE_SIZE = 20
import SelectInside from '_vc/select-inside'
export default {
    name: 'moduleEmpSetup',
    components: { SelectInside },
    inject: {
        $modal: {
            default: null
        }
    },
    props: {
        list: Array,
        default: () => []
    },
    data() {
        return {
            moduleList: [],
            loading: false,
            mtHeight: 420,
            moduleId: '',
            verifyIds: '',
            peopleIds: '',
            empOptions: [],
            dict: {
                authModule: Dict.NULL
            }
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    width: 60,
                    title: '序号',
                    align: 'center'
                },
                {
                    title: '模块名称',
                    align: 'left',
                    key: 'module',
                    render: mapCell(this.dict.authModule.val())
                }
            ]
        }
    },
    methods: {
        lookupChange(data) {
            this.beforeChange()
        },
        beforeChange() {
            if (this.verifyIds != this.peopleIds) {
                let data = { module: this.moduleId, dataIds: this.peopleIds }
                return doAuth(data)
            } else {
                return Promise.resolve()
            }
        },
        chooseModule(row) {
            this.loading = true
            this.beforeChange()
                .then(() => {
                    return queryAuth(row.module)
                })
                .then(res => {
                    this.moduleId = row.module
                    this.setEmpList(res.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setEmpList(data) {
            let ids = []
            data.list.forEach(el => {
                ids.push(el.dataId)
                this.empOptions.push({
                    id: el.dataId,
                    nickname: el.realname
                })
            })
            this.peopleIds = ids.join(',')
            this.verifyIds = ids.join(',')
        }
    },
    mounted() {
        this.$modal.beforeEnter(next => {
            Dict.get(['auth_module'])
                .then(res => {
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = res[name]
                    })
                    let list = JSON.parse(JSON.stringify(this.list))
                    if (list[0]) {
                        list[0]._highlight = true
                        this.moduleId = list[0].module
                        return queryAuth(this.moduleId)
                            .then(res => {
                                this.setEmpList(res.data)
                            })
                            .finally(() => {
                                this.moduleList = list
                            })
                    } else {
                        return Promise.resolve()
                    }
                })
                .finally(() => next())
        })
        this.$modal.onBtnClick('confirm', (next, options) => {
            this.beforeChange()
                .then(res => {
                    if (res && res.code == 200) {
                        this.$Message.success(this.$t('tips.save.success'))
                    }
                })
                .catch(res => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
